import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { withEnvironment } from "../extensions/with-environment"

/**
 * 全域通知 store
 */

export const functionType = types.custom<string, () => void>({
  name: "functionType",
  fromSnapshot(value: string) {
    return parseFunction(value)
  },
  toSnapshot(value: () => void) {
    if (!value.toString()) {
      return null
    } else {
      return value.toString()
    }
  },
  getValidationMessage(value: string) {
    try {
      parseFunction(value)
      return null
    } catch (e) {
      return `value "${value}" is Not a valid function ${e}`
    }
  },
  isTargetType(value: any) {
    return value instanceof Function
  },
})

export const GlobalToastStoreModel = types
  .model("GlobalToastStore")
  .props({
    isGlobalToastShowing: types.optional(types.boolean, false),
    title: types.maybeNull(types.string),
    content: types.maybeNull(types.string),
    submitBtnText: types.maybeNull(types.string),
    cancelBtnText: types.maybeNull(types.string),
  })
  .volatile(() => ({
    handleSubmit: functionType,
    handleCancel: functionType,
  }))
  .extend(withEnvironment)
  .views(() => ({}))
  .actions((self) => {
    const setGlobalToast = (deta) => {
      self.title = deta.title
      self.content = deta.content
      self.isGlobalToastShowing = true
      self.submitBtnText = deta.submitBtnText
      self.cancelBtnText = deta.cancelBtnText
      self.handleSubmit = deta.handleSubmit
      self.handleCancel = deta.handleCancel
    }
    const cleanGlobalToast = () => {
      self.isGlobalToastShowing = false
      self.title = ""
      self.content = ""
      self.submitBtnText = ""
      self.cancelBtnText = ""
      self.handleSubmit = null
      self.handleCancel = null
    }

    return {
      setGlobalToast,
      cleanGlobalToast,
    }
  })

const parseFunction = (value: string) => {
  // eslint-disable-next-line no-eval
  const fn = eval(`(${value})`)
  if (typeof fn !== "function") throw new Error(`${value} is not a valid function`)
  return fn
}

type GlobalToastStoreType = Instance<typeof GlobalToastStoreModel>
export interface GlobalToastStore extends GlobalToastStoreType {}
type GlobalToastStoreSnapshotType = SnapshotOut<typeof GlobalToastStoreModel>
export interface GlobalToastStoreSnapshot extends GlobalToastStoreSnapshotType {}
export const createGlobalToastStoreDefaultModel = () => types.optional(GlobalToastStoreModel, {})
